import {Component, tag} from 'doz'
import Day from './day'
import 'doz-tab'
import adapters from './adapters'
/*
weekday[0] = 1 "Monday";
weekday[1] = 2 "Tuesday";
weekday[2] = 3 "Wednesday";
weekday[3] = 4 "Thursday";
weekday[4] = 5 "Friday";
weekday[5] = 6 "Saturday";
weekday[6] = 0 "Sunday";
 */
const daysMap = [ 6, 0, 1, 2, 3, 4, 5];
//console.log(daysMap[new Date().getDay()])
//console.log(new Date().getDay())

@tag('programs')
export default class extends Component {
    props = {
        mon: [],
        tue: [],
        wed: [],
        thu: [],
        fri: [],
        sat: [],
        sun: [],
    };

    template(h) {
        let today = new Date().getDay();
        return h`
            <style>
                .container{
                    color: ${this.THEME.onPrimaryColor};
                    background: ${this.PLAYER_CONFIG.programsBackgroundColor || this.THEME.primaryColor};
                    border-color: ${this.PLAYER_CONFIG.programsSeparatorColor};
                    text-align:left;
                    display: block;
                }
                
                doz-tab {
                    width: 100%;
                }
                
                .tab-buttons {
                    border-radius: 8px;
                    overflow: hidden;
                    margin-bottom: 8px!important;
                }
                
                h3 {
                    color: ${this.PLAYER_CONFIG.programsTitleColor || this.THEME.onPrimaryColor};
                }
            </style>
            <div class="container" id="myContainer">
                <h3>${this.PLAYER_CONFIG.programsTitleText || ''}</h3>
                <doz-tab initial="${daysMap[today]}" 
                    buttons-size="small" 
                    body-background-color="${this.PLAYER_CONFIG.programsBackgroundColor || this.THEME.primaryColor}" 
                    button-color="${this.PLAYER_CONFIG.programsButtonTextColor || this.THEME.primaryColor}"
                    button-background-color="${this.PLAYER_CONFIG.programsButtonBackgroundColor || this.THEME.onPrimaryColor}" 
                    button-hover-color="${this.PLAYER_CONFIG.programsButtonHoverTextColor || this.THEME.onPrimaryColor}"
                    button-hover-background-color="${this.PLAYER_CONFIG.programsButtonHoverBackgroundColor || this.THEME.primaryColorDark}" 
                    button-selected-color="${this.PLAYER_CONFIG.programsButtonSelectedTextColor || this.THEME.onPrimaryColor}"
                    button-selected-background-color="${this.PLAYER_CONFIG.programsButtonSelectedBackgroundColor || this.THEME.primaryColorDark}"
                    height="${this.PLAYER_CONFIG.isShowProgramsOnly ? '1200px' : '300px'}">
                    <doz-tab-item title="LUN"> 
                        <${Day} is-today="${1 === today}" hours="${this.props.mon}"/>
                    </doz-tab-item> 
                    <doz-tab-item title="MAR"> 
                        <${Day} is-today="${2 === today}" hours="${this.props.tue}"/>
                    </doz-tab-item> 
                    <doz-tab-item title="MER"> 
                        <${Day} is-today="${3 === today}" hours="${this.props.wed}"/>
                    </doz-tab-item> 
                    <doz-tab-item title="GIO"> 
                        <${Day} is-today="${4 === today}" hours="${this.props.thu}"/>
                    </doz-tab-item> 
                    <doz-tab-item title="VEN"> 
                        <${Day} is-today="${5 === today}" hours="${this.props.fri}"/>
                    </doz-tab-item> 
                    <doz-tab-item title="SAB"> 
                        <${Day} is-today="${6 === today}" hours="${this.props.sat}"/>
                    </doz-tab-item> 
                    <doz-tab-item title="DOM"> 
                        <${Day} is-today="${0 === today}" hours="${this.props.sun}"/>
                    </doz-tab-item> 
                </doz-tab>
            </div>
        `
    }

    onMount() {
        if (this.isSSR()) return;
        this.getData();
        setInterval(() => this.getData(),30000);

        const container = document.getElementById('myContainer');
        if (!this.PLAYER_CONFIG.programsTitleText) {
            container.style.marginTop = '-20px';
            container.style.marginLeft = '-20px';
            container.style.marginRight = '-20px';
        }

        setTimeout(() => {
            document.querySelectorAll('.tab-buttons li').forEach((item, i) => {
                item.setAttribute('tabindex', i);
            });
        }, 100)
    }

    getData(){
        if (this.PLAYER_CONFIG.programsType === 'OURJSON' || this.PLAYER_CONFIG.programsType === 'RAI') {
            if (this.PLAYER_CONFIG.programsJsonType === 1) {
                try {
                    this.props = JSON.parse(this.PLAYER_CONFIG.programsJson).days;
                    //console.log(this.props)
                } catch (e) {
                    console.error(e);
                }
            } else if (this.PLAYER_CONFIG.programsJsonType === 2) {
                this.axios.get(this.CONFIG.API_XDEVEL_BASES_URL + '/radioplayer/mobileview/schedule-json-read/' + (window.PLAYER_ID * this.CONFIG.INT_ID) + '?clientId=' + this.CONFIG.API_XDEVEL_CLIENT_ID)
                    .then(response => {
                        //console.log(response.data.result.days)
                        if (response.data && response.data.result) {
                            this.props = response.data.result.days;
                        }
                    })
                    .catch(error => {
                        console.error(error);
                    })
            } else {

                let url = this.PLAYER_CONFIG.programsUrl;

                this.axios.get(this.CORS_PROXY + url)
                    .then(response => {
                        if (response.data) {
                            this.props = response.data.days;
                        }
                    })
                    .catch(error => {
                        console.error(error);
                    });
            }
        } else {
            let url = this.PLAYER_CONFIG.programsUrl;
            // ADAPTERS
            const adapter = adapters[this.PLAYER_CONFIG.programOnAirType];
            if (!adapter) return;
            this.axios.get(this.CORS_PROXY + url)
                .then(response => {
                    if(response.data){
                        adapter(response.data, this);
                    }
                })
                .catch (error => {
                    console.error(error);
                });
        }
    }

}
